export const getLocalStorage = (key) => {
  const data = localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : null;
  return data;
};

export const setLocalStorage = (key, value) => {
  const data = JSON.stringify(value);
  localStorage.setItem(key, data);
};

export const removeLocalStorage = (key) => localStorage.removeItem(key);

export const clearLocalStorage = () => localStorage.clear();